import { IHeaderParams } from "ag-grid-community";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import AppCheckBox from "@/features/line-sheet-sets/app-checkbox";
import { useEffect, useState } from "react";
import useOrderSheetSetPagePersistedQuery
  from "@/features/order-sheet-sets/hooks/use-order-sheet-set-page-persisted-query";
import useIdentity from "@/features/ui/hooks/use-identity";

interface SheetCheckBoxHeaderProps extends IHeaderParams {
  items?: string[];
}

export default function SheetCheckBoxHeader({ api, items }: SheetCheckBoxHeaderProps) {
  const { t } = useI18nHelper();
  const [totalCount, setTotalCount] = useState<number>(0);
  const [checkedCount, setCheckedCount] = useState<number>(0);

  const { value: query, set: setQuery } = useOrderSheetSetPagePersistedQuery();

  const identity = useIdentity();
  const isBuyer = identity?.company?.type === "BUYER";

  const isFiltered = Boolean(
    (query.brandName__eq && query.brandName__eq.length > 0) ||
    query.gender__eq ||
    query.category__eq ||
    query.season__in ||
    query.query
  );

  useEffect(() => {
    const updateSelectionState = () => {
      // Check if all rows are selected
      let totalRowCount = 0;
      let checkedRowCount = 0;
      api.forEachNode((n) => {
        if (n.data && n.data.id > 0) {
          totalRowCount += 1;
          if (n.isSelected()) {
            checkedRowCount += 1;
          }
        }
      });
      setCheckedCount(checkedRowCount);
      setTotalCount(totalRowCount);
    };

    updateSelectionState();

    api.addEventListener("selectionChanged", updateSelectionState);

    return () => {
      api.removeEventListener("selectionChanged", updateSelectionState);
    };
  }, [api]);

  return (
    <AppCheckBox
      size={"small"}
      isChecked={totalCount > 0 && checkedCount === totalCount}
      isIndeterminate={checkedCount > 0 && checkedCount < totalCount}
      onChange={(value) => {
        if (isFiltered && isBuyer) {
          api.forEachNode((n) => {
            if (n.data && (n.data.id == -1 || n.data.id == -2)) {
              n.setSelected(value)
              n.data.indeterminate = false;
            }
          });
        } else {

          if (value) {
            api.selectAll();
          } else {
            api.deselectAll();
          }
        }
      }}
    />
  );
}
